import { memo } from 'react';

import InsightCard from './InsightCard.jsx';

export const INSIGHT_GRID_CLASS = 'grid grid-cols-1 gap-4 md:grid-cols-2';

/** Insight cards in the two-column grid (one column below `md`) (CT-5716). */
const InsightGrid = memo(function InsightGrid({ cards, openInsightId = null, onOpen }) {
  return (
    <div className={INSIGHT_GRID_CLASS}>
      {cards.map((insight) => (
        <InsightCard key={insight.id} insight={insight} selected={insight.id === openInsightId} onOpen={onOpen} />
      ))}
    </div>
  );
});

export default InsightGrid;
